"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function conditional(condition, content) {
    return condition ? content : undefined;
}
exports.conditional = conditional;
function makeTestId() {
    var parts = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        parts[_i] = arguments[_i];
    }
    return parts.join('-');
}
exports.makeTestId = makeTestId;
function isAlphabeticChar(char) {
    return !!char && /^[a-z0-9]$/i.test(char);
}
exports.isAlphabeticChar = isAlphabeticChar;
//# sourceMappingURL=Declarative.js.map